import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';
import { useModuleStore } from '../../enrollment-process/module-management/model/ModuleStoreHook';
import { useObserver } from 'mobx-react-lite';
import { YlInput } from '../../../infrastructure/forms/YlInput';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../root/RootStoreHooks';
import { useModuleDisplayMode } from '../../enrollment-process/steps-management/components/step-layouts/accordion/ModuleDisplayMode';

export const GovernmentEntryDisplay: FC = () => {
  const governmentEntry = useModuleStore('governmentEntry');
  const rootStore = useRootStore();
  const { t } = useTranslation();
  return useObserver(() => (
    <div>
      <span>{t('governmentId')}: </span>
      {rootStore.moduleStores.governmentEntry && (<span className="text-primary">{`${governmentEntry.governmentId}`}</span>)}
    </div>
  ));
};

export const GovernmentEntry = () => {
  const governmentEntryStore = useModuleStore('governmentEntry');
  const moduleDisplayMode = useModuleDisplayMode();
  return useObserver(() => {
       if (moduleDisplayMode) {
          return <GovernmentEntryDisplay />;
        }
    return (
      <>
        <Form className="governmentForm">
          <Form.Row>
            <YlInput
              id="governmentId"
              required={true}
              customAttributes={{ maxLength: 16 }}
              field={governmentEntryStore.reactForm.$.governmentId}
              label="governmentId"
              size={4}
              onChange={value => governmentEntryStore.applyFormat(value)}
            />
          </Form.Row>
        </Form>
      </>
    );
  });
};
